import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { SidebarComponent } from './app/sidebar/sidebar.component';
import { HeaderComponent } from './app/header/header.component';
import { SharedModule } from '../shared/shared.module';
import { WebsocketBalancesService } from '../exchange/services/websocket-balances.service';
import { ExchangeService } from '../exchange/services/exchange.service';
import { UserPortfolioComponent } from './app/user-portfolio/user-portfolio.component';
import { ExchangeBalanceComponent } from './app/exchange-balance-new/exchange-balance.component';
import { UserMenuNavComponent } from './app/user-menu/user-menu.component';
import { UserIconComponent } from './components/user-icon/user-icon.component';
import { MobileMenuComponent } from './app/mobile-menu/mobile-menu.component';
import { UserMenuMainComponent } from './content/user-menu-main/user-menu-main.component';
import { UserMenuNavigationComponent } from './content/user-menu-navigation/user-menu-navigation.component';
import { TabMenuComponent } from './components/tab-menu/tab-menu.component';
import { TabComponent } from './components/tab/tab.component';
import { MobileMenuSiteComponent } from './app/mobile-menu-site/mobile-menu-site.component';
import { MenuToggleComponent } from './components/menu-toggle/menu-toggle.component';
import {GeneralModule} from '../general/general.module';


@NgModule({
  providers: [WebsocketBalancesService, ExchangeService],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    GeneralModule,
  ],
  declarations: [
    MenuItemComponent,
    SidebarComponent,
    HeaderComponent,
    UserPortfolioComponent,
    ExchangeBalanceComponent,
    UserMenuNavComponent,
    UserIconComponent,
    MobileMenuComponent,
    UserMenuMainComponent,
    UserMenuNavigationComponent,
    TabComponent,
    TabMenuComponent,
    MobileMenuSiteComponent,
    MenuToggleComponent,
  ],
  exports: [
    SidebarComponent,
    HeaderComponent,
    UserPortfolioComponent,
    TabComponent,
    TabMenuComponent,
    UserMenuNavComponent,
    MobileMenuSiteComponent,
  ]
})
export class NavigationModule { }
